import { fromJS } from 'immutable';

export function request( state, { provider } ) {
    return state.set( provider, fromJS( {
        status: 'IN_PROGRESS'
    } ) );
}

export function finish( state, { provider, games } ) {
    return state.set( provider, fromJS( {
        status: 'FINISHED',
        items: games
    } ) );
}

export function error( state, { provider } ) {
    return state.set( provider, fromJS( {
        status: 'ERROR'
    } ) );
}
